import React, { useEffect, useState } from 'react';
import { usePreservedCallback } from '@toss/react';
import { debounce } from 'lodash-es';
import { useTranslation } from 'next-i18next';
import { SpacesQuery } from '@zep/types';
import { Input } from '@zep/ui';
import { useSearchFilterContext } from '../../../contexts';
import S from './MobileSearchInput.module.scss';
import { MAXIMUM_QUERY_LENGTH } from './SpaceListContent';
export const MobileSpaceSearchInput = () => {
  const {
    t
  } = useTranslation(['home'], {
    useSuspense: true
  });
  const {
    setSearchQuery,
    filterType
  } = useSearchFilterContext();
  const [searchValue, setSearchValue] = useState('');
  const debouncedSetSearchQuery = usePreservedCallback(debounce(value => {
    if (value.length >= 2) {
      setSearchQuery(value);
    } else {
      setSearchQuery('');
    }
  }, 300));
  const handleChangeInputValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };
  useEffect(() => {
    debouncedSetSearchQuery(searchValue);
  }, [searchValue, debouncedSetSearchQuery]);
  useEffect(() => {
    setSearchValue('');
  }, [filterType]);
  return <div className={S.bottom_module_wrapper} data-sentry-component="MobileSpaceSearchInput" data-sentry-source-file="MobileSearchInput.tsx">
      <Input value={searchValue} className={S.custom_input} placeholder={filterType === SpacesQuery.RECENT ? t('home:space_me_search_visited_spaces') : t('home:space_me_search_my_spaces')} onChange={handleChangeInputValue} autoFocus isFullWidth maxLength={MAXIMUM_QUERY_LENGTH} data-sentry-element="Input" data-sentry-source-file="MobileSearchInput.tsx" />
    </div>;
};